module.exports = __webpack_public_path__ + "img/hand_stop.0060c6c4.svg";